export const AnalyticsDataKey = {
  TotalCalls: 'totalCalls',
  AnsweredCalls: 'answeredCalls',
  MissedCalls: 'missedCalls',
  AbandonedCalls: 'abandonedCalls',
} as const;

export const PhoneAnalyticsEntity = {
  Group: 'Group',
  Queue: 'Queue',
  PhoneTrees: 'Phone Trees',
} as const;

export type EntityType = (typeof PhoneAnalyticsEntity)[keyof typeof PhoneAnalyticsEntity];

type AnalyticsDataItem = AnalyticsData & {
  callGroupId?: string;
  callQueueId?: string;
};

export type ChartView = 'dashboard' | 'table';
export type GroupPanelContainerProps = {
  filterHintText: string;
  isLoading?: boolean;
  data?: AnalyticsDataItem[];
  customNameHeaders: Record<
    string,
    {
      name: string;
      devicesCount: number;
    }
  >;
  entityType: EntityType;
  children?: React.ReactNode;
};

export type AnalyticsData = {
  [AnalyticsDataKey.TotalCalls]?: number;
  [AnalyticsDataKey.AnsweredCalls]?: number;
  [AnalyticsDataKey.MissedCalls]?: number;
  [AnalyticsDataKey.AbandonedCalls]?: number;
};

export type GroupItemsProp = Pick<
  GroupPanelContainerProps,
  'entityType' | 'children' | 'customNameHeaders' | 'filterHintText'
> & {
  categoryBarChartData: Record<string, Required<AnalyticsData>>;
  title: string;
};
